<template>
  <AppContainer>
    <router-view />
  </AppContainer>
</template>

<script>
import { mapGetters } from 'vuex';

import AppContainer from '@/components/AppContainer';
export default {
  components: { AppContainer },
  computed: mapGetters('app', ['toastr']),
  watch: {
    toastr: function({ type, msg, title }) {
      if (typeof this.$toastr[type] !== 'function') return;
      this.$toastr[type](msg || '', title || '');
    },
  },
};
</script>
